import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  MenuItem,
  Select,
  CircularProgress,
  Paper,
  Box,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { CloudUploadRounded } from "@mui/icons-material";
import Key from "../../../clientVariables.json";
import {
  addCandidateAction,
  alertSnackBarAction,
  getCandidateDetailAction,
  getActiveCandidatesAction,
  getCandidatesAction,
  resetCandidatesAction,
} from "../../redux/action";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { userSelector } from "../../user-redux/selector";
import { validateReoonEmailVerification } from "../../../helpers/EmailFieldValidator";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddCandidate = ({
  check,
  candidatesRefreshHandler,
  closeResumeParserModal,
  popupsHandler,
  getCandidateResumeList,
  fetchResumesAfterUpload,
}) => {
  const dispatch = useDispatch();
  const { selectedCandidate, candidateDetails, loginCandidate } =
    useSelector(appSelector);

  const { user } = useSelector(userSelector);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [parsedFileData, setParsedFileData] = useState([]);
  const [addCandidateData, setAddCandidateData] = useState([]);
  const [addResumesData, setAddResumesData] = useState([]);
  const [addCandidateAndAddResumeToS3, setAddCandidateAndAddResumeToS3] =
    useState([]);
  const [comonApiLoad, setComonApiLoad] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    // firstName: "",
    // lastName: "",
    email: "",
    jobTitle: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const MAX_FILES = 5;

  const validateForm = async () => {
    let errors = {};
    let isValid = true;

    if (!formData.fullName.trim()) {
      errors.fullName = "Full Name is required";
      isValid = false;
    }

    // if (!formData.lastName.trim()) {
    //   errors.lastName = "Last Name is required";
    //   isValid = false;
    // }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (user.username === formData.email) {
      errors.email = "The email address already exists in the system.";
      isValid = false;
    } else {
      try {
        const response = await validateReoonEmailVerification(formData.email);
        if (!response.valid) {
          errors.email = response.message;
          isValid = false;
        }
      } catch (error) {
        console.error("Email verification error:", error);
        errors.email = "Email verification failed";
        isValid = false;
      }
    }

    if (!formData.jobTitle.trim()) {
      errors.jobTitle = "Job Title is required";
      isValid = false;
    }

    setFormErrors(errors);
    console.log("Form errors:", errors);
    return isValid;
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      if (check === "add_candidates") {
        const singleFile = files[0]; // Only take the first file
        validateAndAddFile(singleFile);
        getParseData(singleFile);
      } else if (check === "add_resumes") {
        // Allow multiple file uploads for add_resumes
        Array.from(files).forEach((file) => {
          validateAndAddFile(file);
          getParseData(file);
        });
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (check === "add_candidates") {
      // Only take the first file if adding candidates
      if (files.length > 0) {
        const singleFile = files[0];
        validateAndAddFile(singleFile);
        getParseData(singleFile);
      }
    } else if (check === "add_resumes") {
      // Allow multiple file drops for adding resumes
      Array.from(files).forEach((file) => {
        validateAndAddFile(file);
        getParseData(file);
      });
    }
  };

  const validateAndAddFile = (file) => {
    const allowedFileTypes = [".docx", ".pdf", ".doc"];

    if (selectedFiles.length >= MAX_FILES) {
      popupsHandler(`You can upload a maximum of ${MAX_FILES} files.`, "error");
    } else if (
      !allowedFileTypes.includes(file.name.slice(file.name.lastIndexOf(".")))
    ) {
      popupsHandler(
        `You can add only .docx and .pdf files. The following file was not added: ${file.name}`,
        "error"
      );
    } else {
      setSelectedFiles([...selectedFiles, file]);
    }
  };

  const handleRemove = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    setFormOpen(false);
    setFormData({
      fullName: "",
      //lastName: "",
      email: "",
      jobTitle: "",
    });
  };

  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      return false;
    }

    const invalidDomains = ["example.com", "test.com", "email.com"];

    const domain = email.split("@")[1];

    if (invalidDomains.includes(domain)) {
      return false;
    }

    return true;
  }

  const handleUpload = async () => {
    // setIsUploading(true);

    try {
      if (selectedFiles.length > 0) {
        if (check === "add_candidates") {
          const isFormValid = await validateForm();
          if (isFormValid) {
            setIsUploading(true);
            for (const element of addCandidateData) {

              element.candidateData.fullName = formData.fullName;
              //element.candidateData.lastname = formData.lastName;
              element.candidateData.email = formData.email;
              element.candidateData.jobtitle = formData.jobTitle;

              const rawEmail = element?.candidateData?.email;
              const rawPhone = element?.candidateData?.phone;
              const parsedEmail = Array.isArray(rawEmail)
                ? rawEmail[0]
                : rawEmail || null;
              const parsedPhone = Array.isArray(rawPhone)
                ? rawPhone[0]
                : rawPhone || null;
              // const validEmail = await validateEmail(parsedEmail);

              if (parsedEmail) {
                const responseData = await dispatch(
                  addCandidateAction(
                    element?.candidateData,
                    user?.usertype == 13 ? user?.admin_id != null ? user?.admin_id : user?.id : user?.id,
                    element?.fileData
                  )
                );
                await dispatch(resetCandidatesAction());
                const userId = user?.usertype == 13
                  ? (user?.admin_id && user?.admin_id.trim() ? user?.admin_id : user?.id)
                  : user?.id
                await dispatch(getActiveCandidatesAction(userId, 1, 20));

                if (responseData.data === "Candidate already exist") {
                  await dispatch(getActiveCandidatesAction(user?.id, 1, 20));
                  popupsHandler(responseData.data, "error");
                }
                const resume = addCandidateAndAddResumeToS3.find(
                  (item) => item.fileData === element.fileData
                );
                const resumeData = resume?.parsedData;
                const file = resume?.fileData;
                if (responseData?.data?.userResult?.insertId) {
                  handleUpdateCandidateDetails(
                    responseData?.data.candidateResults?.insertId
                  );
                  const solrSearchArray = (resumeData?.solr_searchstring || "")
                    .replace("job_role:(", "")
                    .replace(/\\"/g, '"')
                    .replace(")", "")
                    .split(" OR ");
                  const resumePayload = {
                    candidate_id: responseData?.data.candidateResults?.insertId,
                    ai_skills: resumeData?.skills?.join(","),
                    user_id: responseData?.data.userResult?.insertId,
                    application_title: formData.jobTitle,
                    full_name: formData.fullName,
                    first_name: resumeData?.first_name,
                    last_name: resumeData?.last_name,
                    home_phone: parsedPhone,
                    email_address: parsedEmail,
                    total_experience: resumeData?.experience_in_years,
                    location_state: resumeData?.state || "",
                    location_city: resumeData?.city || "",
                    address_zipcode: "",
                    skills_ids: "",
                    summary: resumeData?.summary || "",
                    current_role: formData.jobTitle,
                    status: "1",
                    skills_titles: resumeData?.related_skills?.join(",") || "",
                    location_country: "",
                    jobtype: "",
                    uploaded_uid: user?.id,
                    visatype: resumeData?.visa || "",
                    full_address:
                      resumeData?.location !== ", "
                        ? resumeData?.location
                        : "" || "",
                    resume_string: resumeData?.resume_string || "",
                    willingToRelocate: "",
                    solr_search_string:
                      resumeData?.solr_searchstring !== "" &&
                        resumeData?.solr_searchstring !== null
                        ? resumeData?.solr_searchstring
                        : "",
                    source: "fromBenchsales",
                    primary: 1,
                    linkedin_url:
                      resumeData?.linkedin_url !== ""
                        ? resumeData?.linkedin_url
                        : "",
                    filename: resumeData?.filename,
                    projects_data:
                      resumeData?.projects?.length > 0
                        ? resumeData?.projects
                        : [],
                    educations_data:
                      resumeData?.educations?.length > 0
                        ? resumeData?.educations
                        : [],
                    certificates_data:
                      resumeData?.certifications?.length > 0
                        ? resumeData?.certifications
                        : [],
                  };
                  const response = await axios.post(
                    `${Key.domain}/candidate/bench_addFullResume`,
                    resumePayload
                  );
                  const resumeId = response?.data?.data?.insertId;
                  const data = new FormData();
                  data.append("file", file);
                  data.append("userid", resumePayload?.user_id);
                  data.append("candidateid", resumePayload?.candidate_id);
                  data.append("filename", file?.name);
                  data.append("file_size", file?.size);
                  data.append("file_type", file?.type);
                  data.append("attachment_type", "Candidate_res_attachment");
                  data.append("attachment_name", file?.name);
                  data.append("file_created", file?.lastModifiedDate);
                  data.append("resumeid", resumeId);
                  data.append("role", resumeData?.job_title);
                  await axios.post(
                    `${Key.domain}/candidate/upload_document`,
                    data
                  );
                  await fetchResumesAfterUpload?.(
                    responseData?.data?.candidateResults?.insertId,
                    responseData?.data?.userResult?.insertId
                  );
                  popupsHandler("Candidate added successfully", "success");
                }
                setIsUploading(false);
                closeResumeParserModal(true);
              } else {
                popupsHandler(`Invalid email: ${parsedEmail}`, "error");
              }
            }
          } else {
            // console.log("Form validation failed:", formErrors);
          }
        } else if (check === "add_resumes") {
          setIsUploading(true);
          for (let i = 0; i < addResumesData.length; i++) {
            const resumeData = addResumesData[i];
            const file = addCandidateAndAddResumeToS3[i].fileData;
            const response = await axios.post(
              `${Key.domain}/candidate/bench_addFullResume`,
              resumeData
            );
            const resumeId = response?.data?.data?.insertId;
            const data = new FormData();
            data.append("file", file);
            //data.append("file", file);
            data.append("userid", candidateDetails?.user_id);
            data.append("candidateid", candidateDetails?.candidate_id);
            data.append("filename", file?.name);
            data.append("file_size", file?.size);
            data.append("file_type", file?.type);
            data.append("attachment_type", "Candidate_res_attachment");
            data.append("attachment_name", file?.name);
            data.append("file_created", file?.lastModifiedDate);
            data.append("resumeid", resumeId);
            data.append("role", resumeData?.application_title);

            await axios.post(`${Key.domain}/candidate/upload_document`, data);

            popupsHandler("Resume added successfully", "success");
            getCandidateResumeList();
          }
          setIsUploading(false);
          closeResumeParserModal(true);
        }
      } else {
        popupsHandler("No files selected", "warning");
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      // popupsHandler("Failed to upload files11111", "error");
      setIsUploading(false);
      closeResumeParserModal(true);
    }
  };

  const getParseData = async (fileData) => {
    setComonApiLoad(true);
    try {
      const formData = new FormData();
      formData.append("resume", fileData);

      const response = await fetch(Key.resume_parser_ai_4, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to parse data: ${response.statusText}`);
      }

      const body = await response.json();

      const email = Array.isArray(body.data?.email)
        ? body.data.email[0]
        : body.data?.email || "";
      const phone = Array.isArray(body.data?.phone)
        ? body.data.phone[0]
        : body.data?.phone || "";

      if (
        body.statusCode === 200 &&
        body.data !== undefined &&
        body.data !== null
      ) {
        if (check === "add_candidates") {
          const candidateData = await {
            admin_id: user?.usertype == 13
              ? (user?.admin_id && user?.admin_id.trim() ? user?.admin_id : user?.id)
              : user?.id,
            name: body.data?.name,
            firstname: body.data?.first_name,
            middlename: "",
            lastname: body.data?.last_name,
            email: email,
            phone: phone,
            date_of_birth: "",
            candidate_status: "Active",
            jobtitle: body.data?.job_title,
            visatype: body.data?.visa,
            related_titles: body.data?.solr_searchstring,
            experience: body.data?.experience_in_years,
            address: "",
            zipcode: "",
            countryid: "",
            stateid: "",
            cityid: "",
            skills: body.data?.skills,
            summary: body.data?.summary,
            linkedInUrl: body.data?.linkedin_url,
            jobtypeid: "",
            availabledate: "",
            ratefrom: "",
            rateto: "",
            currentratetype: "",
            currentrate: "",
            gender: "",
            willingToRelocate: "No",
            role: body.data?.job_title,
            companyid: user?.companyid,
          };
          //console.log("Full summary from parser:", body.data?.summary?.length, body.data?.summary);
          setAddCandidateData((prev) => [
            ...prev,
            { fileData, parsedData: body.data, candidateData },
          ]);
          setAddCandidateAndAddResumeToS3((prev) => [
            ...prev,
            { parsedData: body.data, fileData },
          ]);
          setFormData({
            ...formData,
            fullName: body.data.name || "",
            // firstName: body.data.first_name || "",
            // lastName: body.data.last_name || "",
            email: email || "",
            jobTitle: body.data.job_title || "",
          });
          setFormOpen(true);
          popupsHandler("Resume parsed successfully", "success");
        } else if (check === "add_resumes") {
          const inputString = (await body.data?.solr_searchstring) || "";
          const solrSearchArray = await inputString
            .replace("job_role:(", "")
            .replace(/\\"/g, '"')
            .replace(")", "")
            .split(" OR ");
          const resumeData = await {
            candidate_id: selectedCandidate?.candidate_id
              ? selectedCandidate?.candidate_id
              : candidateDetails?.candidate_id,
            ai_skills: body.data?.skills?.join(",") || "",
            user_id: user?.id,
            application_title: body.data?.job_title || "",
            full_name: body.data?.name || "",
            first_name: body.data?.first_name || "",
            last_name: body.data?.last_name || "",
            home_phone: phone,
            email_address: email,
            total_experience: body.data?.experience_in_years,
            location_state: body.data?.state || "",
            location_city: body.data?.city || "",
            address_zipcode: "",
            skills_ids: "",
            summary: body.data?.summary || "",
            current_role: body.data?.job_title,
            status: "1",
            skills_titles: body.data?.related_skills?.join(",") || "",
            location_country: "",
            jobtype: "",
            visatype: body.data?.visa || "",
            full_address: body.data?.location || "",
            resume_string: body.data?.resume_string || "",
            willingToRelocate: "",
            solr_search_string:
              body.data?.solr_searchstring !== "" &&
                body.data?.solr_searchstring !== null
                ? body.data?.solr_searchstring
                : "",
            source: "fromBenchsales",
            primary: "",
            linkedin_url: body.data?.linkedin_url || "",
            filename: body.data?.filename,
            projects_data: body.data?.projects || [],
            educations_data: body.data?.educations || [],
            certificates_data: body.data?.certifications || [],
            uploaded_id: user?.id,
          };
          setAddResumesData((prev) => [...prev, resumeData]);
          setAddCandidateAndAddResumeToS3((prev) => [
            ...prev,
            { parsedData: body.data, fileData },
          ]);
          popupsHandler("Resume parsed successfully", "success");
        }
      } else {
        throw new Error("Failed to parse data: invalid response format");
      }
    } catch (err) {
      console.error("Error parsing resume:", err);
      popupsHandler("Failed to parse resume, please try again", "error");
    } finally {
      setComonApiLoad(false);
    }
  };

  const handleInputChange = (field) => (event) => {
    const { value } = event.target;
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [field]: value ? "" : prevErrors[field],
    }));
  };

  const handleUpdateCandidateDetails = async (candidateId) => {
    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/personal/${candidateId}`,
        {
          userid: user?.id,
          name: formData.fullName,
          // firstname: formData.firstName,
          // lastname: formData.lastName,
          email: formData.email,
          jobtitle: formData.jobTitle,
        }
      );
      // dispatch(getCandidateDetailAction(selectedCandidate?.candidate_id));
      // popupsHandler("candidate personal details updated", "success");
    } catch (error) {
      console.error(error);
      popupsHandler("something went wrong", "error");
    }
  };

  return (
    <>
      <Paper
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <Typography variant="h6" gutterBottom>
          Upload Resume Files To Add{" "}
          {check === "add_candidates" ? "Candidates" : "Resumes"}
          {/* `Resumes For ${selectedCandidate?.candidate_name}` */}
        </Typography>
        <input
          accept=".docx, .pdf, .doc"
          id="file-upload"
          type="file"
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple
        />
        <label htmlFor="file-upload">
          <Button variant="outlined" component="span">
            {check === "add_candidates" ? "Select File" : "Select Files"}
          </Button>
        </label>
        <CloudUploadRounded
          sx={{ color: "#406882", height: "80px", width: "80px" }}
        />
        <Typography variant="subtitle1" style={{ marginTop: "2px" }}>
          or drag and drop files here
        </Typography>
        {formOpen ? (
          <Grid
            container
            spacing={2}
          // sx={{
          //   ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
          //     padding: "8px 6px",
          //   },
          //   ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
          //     padding: "8px 6px",
          //   },
          //   ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
          //     { padding: "8px 6px" },
          // }}
          >
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="fullName"
                label="Full Name"
                variant="outlined"
                value={formData.fullName}
                error={!!formErrors.fullName}
                helperText={formErrors.fullName || ""}
                onChange={handleInputChange("fullName")}
              />
            </Grid>
            <Grid item xs={12}>
              {/* <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Last Name
                </Typography>
                <TextField
                  id="lastName"
                  label=""
                  variant="outlined"
                  placeholder="Jones"
                  value={formData.lastName}
                  error={!!formErrors.lastName}
                  onChange={handleInputChange("lastName")}
                  sx={inputStyles}
                />
              </FormControl> */}
              {/* <TextField
                fullWidth
                id="lastName"
                placeholder="Last Name"
                label="LastName"
                value={formData.lastName}
                error={!!formErrors.lastName}
                helperText={formErrors.lastName}
                onChange={handleInputChange("lastName")}
              /> */}
            </Grid>

            <Grid item xs={12}>
              {/* <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Email
                </Typography>
                <TextField
                  id="email"
                  label=""
                  variant="outlined"
                  placeholder="James@gmail.com"
                  value={formData.email}
                  error={!!formErrors.email}
                  onChange={handleInputChange("email")}
                  sx={inputStyles}
                />
              </FormControl> */}
              <TextField
                fullWidth
                id="Email"
                placeholder="Email"
                label="Email"
                value={formData.email}
                error={!!formErrors.email}
                helperText={formErrors.email}
                onChange={handleInputChange("email")}
              />
            </Grid>

            <Grid item xs={12}>
              {/* <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Job Title
                </Typography>
                <TextField
                  id="jobTitle"
                  label=""
                  variant="outlined"
                  placeholder="Web Developer"
                  value={formData.jobTitle}
                  error={!!formErrors.jobTitle}
                  onChange={handleInputChange("jobTitle")}
                  sx={inputStyles}
                />
              </FormControl> */}
              <TextField
                fullWidth
                id="jobTitle"
                label="JobTitle"
                placeholder="JobTitle"
                value={formData.jobTitle}
                error={!!formErrors.jobTitle}
                helperText={formErrors.jobTitle}
                onChange={handleInputChange("jobTitle")}
              />
            </Grid>
          </Grid>
        ) : null}
        {selectedFiles.map((file, index) => (
          <div key={index} style={{ marginTop: "10px", display: "flex" }}>
            <Typography
              sx={{
                minWidth: "150px",
                maxWidth: "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {file.name}
            </Typography>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              style={{ marginLeft: "10px" }}
              onClick={() => handleRemove(index)}
            >
              {comonApiLoad ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Remove"
              )}
            </Button>
          </div>
        ))}
        <Button
          variant="contained"
          fullWidth
          color="primary"
          style={{
            marginTop: "20px",
            backgroundImage:
              "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
            textTransform: "capitalize",
          }}
          disabled={comonApiLoad}
          onClick={handleUpload}
        >
          {isUploading ? (
            <CircularProgress size={20} color="inherit" />
          ) : check === "add_candidates" ? (
            "Add Candidate"
          ) : (
            "Add Resumes"
          )}
        </Button>
      </Paper>
    </>
  );
};

export default AddCandidate;

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
